<!--- question-card horizontal-->
<ng-container *ngIf="type === 'horizontal'">
	<div class="fx-column fx-start-stretch">
		<div class="question-card fx-row fx-space-between-stretch">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="cardData?.title || cardData?.date">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<div class="patch-block fx-row fx-space-between-center">
							<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
							</ng-container>
						</div>
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<div class="title-blk fx-column fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
								</ng-container>
							</div>
							<div class="fx-row-wrap fx-space-between-center">
								<ng-container *ngIf="cardData?.date || cardData?.title">
									<div class="fx-row fx-start-center">
										<div class="contributor fx-row fx-start-center">
											<span>{{locale.translate('mcq')}}</span>
										</div>
										<ng-container *ngIf="cardData?.date">
											<div class="date fx-row fx-start-center" fxLayoutGap="5px">
												<span>{{cardData?.date}}</span>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="cardData?.removable" class="cancel" fxLayoutAlign="start start">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>


<!---vertical---->
<ng-container *ngIf="type === 'vertical'">
	<div class="question-card vertical fx-column fx-start-stretch">
		<div class="fx-column fx-start-stretch fx-grow fx-shrink">
			<div class="patch-block fx-start-start">
				<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
				</ng-container>
			</div>
			<ng-container *ngIf="cardData?.title || cardData?.date">
				<div class="content-block  fx-column fx-space-between-stretch fx-grow fx-shrink">
					<ng-container *ngIf="cardData?.date || cardData?.title">
						<div class="contributor-block fx-row"
							[ngClass]="cardData?.date ? 'fx-space-between-center' : 'fx-end-center'">
							<ng-container>
								<!-- <div class="contributor fx-row fx-start-center">
									<span class="cursor-pointer" (click)="profileInfo(cardData)">{{cardData?.creator}}</span>
									<ng-container *ngIf="![null,undefined].includes(cardData?.usersCount)">
										<span class="sub-caption-2 cursor-pointer" (click)="usersInfo()">+ {{cardData?.usersCount}}</span>
									</ng-container>
								</div> -->
							</ng-container>
							<ng-container *ngIf="cardData?.date">
								<div class="date fx-row fx-start-center" fxLayoutGap="5px">
									<span>{{cardData?.date}}</span>
								</div>
							</ng-container>
						</div>
					</ng-container>
					<ng-container *ngIf="cardData?.date || cardData?.title">
						<div class="overview-block fx-column fx-space-between-stretch  fx-grow fx-shrink">
							<div class="fx-column fx-start-stretch fx-grow fx-shrink">
								<div class="title-blk fx-row fx-center-center">
									<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
									</ng-container>
								</div>
							</div>
						</div>
					</ng-container>

				</div>
			</ng-container>
			<div *ngIf="cardData?.removable" class="cancel fx-center-center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>
<!----end-->

<!--- question-card horizontal-->
<ng-container *ngIf="type === 'minimal'">
	<div class="question-card minimal fx-column fx-start-stretch">
		<div class="fx-row fx-start-stretch fx-grow fx-shrink">
			<div class="fx-row fx-start-stretch fx-grow fx-shrink">
				<ng-container *ngIf="cardData?.title">
					<div class="content-block fx-column fx-start-stretch fx-grow fx-shrink">
						<div class="patch-block">
							<ng-container [ngTemplateOutlet]="typePatch" [ngTemplateOutletContext]="data">
							</ng-container>
						</div>
						<div class="overview-block fx-column fx-start-stretch fx-grow fx-shrink">
							<div class="title-blk fx-column fx-grow fx-shrink">
								<ng-container *ngIf="cardData?.title" [ngTemplateOutlet]="title" [ngTemplateOutletContext]="data">
								</ng-container>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
			<div *ngIf="cardData?.removable" class="cancel" fxLayoutAlign="center center">
				<button class="cancel-btn" mat-icon-button #actionBtn
					(click)="close({'actionElement': actionBtn, 'data': cardData})">
					<mat-icon svgIcon="delete"></mat-icon>
				</button>
			</div>
		</div>
	</div>
</ng-container>

<ng-template #title>
	<div fxLayoutAlign="start center">
		<p class="card-title linkable" (click)="info(data)" [innerHtml]="data?.title | safeDom"></p>
	</div>
</ng-template>

<ng-template #typePatch>
	<div class="content-type" fxLayoutAlign="start start">
		<div class="patch sub-txt-patch">{{ locale.translate('question') }}</div>
	</div>
</ng-template>

<ng-template #statusPatch>
	<p class="sub-txt-patch warn">{{ locale.translate('public') }}</p>
</ng-template>